import React, { Component } from 'react';
import { translate } from 'react-translate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Image from '@components/Image';
import { SET_PAGE } from '@redux/easyaccess/types';

import * as S from './styles';

class PageListItem extends Component {
  state = {};

  setPage = (page_id) => {
    const {
      props: { token, dispatch },
    } = this;

    dispatch({
      type: SET_PAGE.REQUEST,
      version: '1.0',
      token,
      body: {
        page_id,
      },
    });
  };

  render() {
    const {
      props: { key, page },
    } = this;

    return (
      <S.PageItem key={key} onClick={() => this.setPage(page.id)}>
        <S.PageImage>
          <Image src={page.picture_url} />
        </S.PageImage>
        <S.PageInfo>
          <S.PageName>{page.name}</S.PageName>
        </S.PageInfo>
      </S.PageItem>
    );
  }
}

export default withRouter(connect()(translate('PageListItem')(PageListItem)));
